/* global google */
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import "./style.css";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import searchImage from "../../assets/images/search-dark.svg";
import locationPin from "../../assets/images/location-pin.svg";
import addressComponentsHelper from "../../helpers/addressComponentsHelper";
import actions from "../../features/createOrder/actions";
import serveActions from "../../features/welcomeScreen/actions";

const api_key = "AIzaSyBaBFJSTCjVaZ5sqb3n4V3zZuGr7GY2ihI";

const { setSearchPlacesResult } = actions;

const { setPositionToServe } = serveActions;

const LocationSearchInputV2 = ({ saveCenter, map, placeholder, intl }) => {
  const [value, setValue] = useState();
  const [suggestions, setSuggestions] = useState([]);
  const [showError, setShowError] = useState(false);

  const inputRef = useRef();
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const fetchSuggestions = async input => {
    if (input.length <= 1) return;

    const GOOGLE_API_KEY = api_key;

    const url = `https://places.googleapis.com/v1/places:autocomplete`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": GOOGLE_API_KEY
        },
        body: JSON.stringify({
          input
        })
      });

      const data = await response.json();

      const placesSuggestion = data?.suggestions?.map(suggestion => {
        return {
          placeId: suggestion.placePrediction.placeId,
          description: suggestion.placePrediction.text.text
        };
      });
      setSuggestions(placesSuggestion);
    } catch (error) {
      console.error("Error when fetching suggestions", error);
    }
  };

  const handleSuggestionSelect = async placeId => {
    const url = `https://places.googleapis.com/v1/places/${placeId}?fields=formattedAddress,addressComponents,location&key=${api_key}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const { formattedAddress, addressComponents, location } = data;
      const addressData = addressComponentsHelper(addressComponents);
      const { latitude, longitude } = location;

      setValue(formattedAddress);
      setSuggestions([]);

      setSearchPlacesResult({
        addressComponents: { ...addressData },
        address: formattedAddress,
        latitude,
        longitude
      });

      setPositionToServe({
        lat: latitude,
        lng: longitude,
        address: `${addressData.route || ""} ${addressData.streetNumber ||
          ""}`.trim(),
        zipCode: addressData.postalCode,
        city: addressData.postalTown
      });

      const currentLatLng = new google.maps.LatLng({
        lat: latitude,
        lng: longitude
      });

      saveCenter(latitude, longitude);
      map.panTo(currentLatLng);
    } catch (e) {
      setShowError(true);
      console.error("Error when fetching place details", e);
    }
  };

  const handleChange = e => {
    fetchSuggestions(e.target.value).then(() => {
      setValue(e?.target?.value);
    });
  };

  return (
    <div className="location-search-input-container">
      <img src={searchImage} alt="search icon" className="search-image-left" />
      <input
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className="location-search-input"
        ref={inputRef}
      />
      {showError && (
        <span className="location-search-input-error">
          {intl.formatMessage({
            id: "DispatchPosition.CarPosition.ErrorMessage",
            defaultMessage: "Choose a valid address",
            description: "CarPosition.ErrorMessage: choose option"
          })}
        </span>
      )}
      <div className="autocomplete-dropdown-container">
        {suggestions.map((suggestion, index) => (
          <div
            key={index}
            onClick={() =>
              handleSuggestionSelect(suggestion.placeId, suggestion.description)
            }
            className="suggestion-item"
          >
            <img
              className="location-pin"
              src={locationPin}
              alt="location pin"
            />
            <span>{suggestion.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

LocationSearchInputV2.propTypes = {
  map: PropTypes.shape({
    panTo: PropTypes.func
  }).isRequired,
  placeholder: PropTypes.string.isRequired,
  saveCenter: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

const mapDispatchToProps = dispatch => ({
  setSearchPlacesResult: data => dispatch(setSearchPlacesResult(data)),
  setPositionToServe: data => dispatch(setPositionToServe(data))
});

export default injectIntl(
  connect(undefined, mapDispatchToProps)(LocationSearchInputV2)
);
